import UploadFile from "./UploadFile"

export default UploadFile;



// WEBPACK FOOTER //
// ./src/components/App/Profile/SubHeader/UploadFile/index.js